<template>
    <div :class="this.$func.storyblok2Css(blok)">
        <h5>{{blok.subheading}}</h5>
    </div>
</template>

<script>
    export default {
        props: ['blok']
    }
</script>